// The proof, read from the customer's Microsoft Entra ID, that a leaving
// vendor's accounts are closed: whether it is switched on and the application
// it reads the directory as.
//
// Its own file rather than more of api.ts, for the reason exit.ts gives: one
// screen's whole client in one place. The settings live on the Entra ID card
// that signs people in, and this route changes only them, so saving here never
// puts sign-in back to draft the way the connector save does.

import { request, type Probe } from './api'

export type EntraProof = {
  // Whether the tenant has an Entra ID card at all. Without one nothing here
  // can be set, and the screen says to connect Entra ID for sign-in first.
  connected: boolean
  connectorId?: string
  enabled: boolean
  graphTenantId: string
  graphClientId: string
  graphClientSecretSet: boolean
  // The card's status, which is sign-in's.
  signIn?: string
  // Whether the directory is actually being read for this tenant.
  collecting: boolean
  lastObservedAt?: string
  lastError?: string
  // Null until something stores the result of the proof's checks. The Test
  // button returns them live.
  probe: { checks: Probe[] } | null
  note: string
}

export type EntraProofSave = {
  enabled: boolean
  graphTenantId: string
  graphClientId: string
  // Omitted keeps the secret already held.
  graphClientSecret?: string
}

const PATH = '/v1/settings/identity/offboarding-proof'

export const entraProofApi = {
  get: () => request<EntraProof>(PATH),
  save: (body: EntraProofSave) => request<EntraProof>(PATH, { method: 'PUT', body: JSON.stringify(body) }),
}

// The checks the connector test adds for the proof, by name, from
// connectors_probe_entra.go. The same test proves sign-in first, and those
// checks belong to the sign-in section rather than to this one.
export const PROOF_CHECKS = [
  "The proof has an application to read the directory as",
  "Microsoft accepts the proof's application",
  'Users can be read',
  'The audit log can be read',
]

// The proof's keys on the card. The sign-in save sends the whole card, so it
// has to send these as they are stored or it would wipe them.
export const PROOF_KEYS = ['offboardingProof', 'graphTenantId', 'graphClientId', 'graphClientSecret']
